import React from 'react'
import BrandingLogo from '../../Icons/Logo'
import LogoNgine from '../../Icons/LogoNgine'

function Logo({ width }) {
  const clientId = localStorage.getItem('clientId')

  return clientId === 'user' ? (
    <LogoNgine width={width} />
  ) : (
    <BrandingLogo width={width} />
  )
}

export default Logo
